import styled from "styled-components";
import LegendCaption from "./legend/LegendCaption";

export const ChartCaptionRoot = styled(LegendCaption)`
  margin: 0 0.5rem;
  flex-shrink: 0;
`;
